import { Components } from '@ionic/core';
import { IonAvatar, IonSpinner } from '@ionic/react';
import {
  DOMAttributes,
  HTMLAttributes,
  ReactElement,
  useEffect,
  useState,
} from 'react';
import { Attachment, Maybe } from '../../api/graphql/generated';
import {
  ImageResolution,
  useAttachmentUrlLazy,
} from '../../api/hooks/attachment.hooks';
import './avatar.css';

export type IonAvatarProps = Partial<Components.IonAvatar> &
  Partial<HTMLAttributes<HTMLIonAvatarElement>> &
  Partial<DOMAttributes<HTMLIonAvatarElement>>;

interface AvatarProps {
  attachment?: Maybe<Attachment>;
  alt?: string;
  avatarProps?: IonAvatarProps;
  updating?: boolean;
  resolution?: ImageResolution;
}

const defaultAvatar = '/assets/avatar.svg';

const Avatar = (props: AvatarProps): ReactElement => {
  const { attachment, alt, updating, avatarProps, resolution } = props;

  const [loaded, setLoaded] = useState<boolean>(false);

  const [src, setSrc] = useState<string>();

  const getAttachmentUrl = useAttachmentUrlLazy();

  useEffect(() => {
    let url: string | undefined = defaultAvatar;

    if (attachment) {
      url = getAttachmentUrl(attachment.path, attachment.contentType, {
        resolution: resolution ?? ImageResolution.THUBMNAIL,
      });
    }

    setSrc(url);
  }, [attachment, getAttachmentUrl, resolution]);

  return (
    <IonAvatar
      {...avatarProps}
      className={['avatar', avatarProps?.className ?? ''].join(' ')}
    >
      <img
        src={src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        onError={() => {
          setLoaded(true);
        }}
      />
      {!loaded || updating ? (
        <IonSpinner className="ion-align-self-center" />
      ) : undefined}
    </IonAvatar>
  );
};

export { Avatar };
